'use strict'

const React = require('react')
const getAirportInfo = require('../getAirportInfo')
const ReviewItem = require('../reviews/reviewItem.jsx')
const Helpers = require('../../../../../_plugins/lib/helpers')
const SchemaTag = require('../SchemaTag.jsx')
const propTypes = require('prop-types');
const DateHelper = require('../../../../../_plugins/lib/dateHelper')
const { string, bool } = propTypes
const createReactClass = require('create-react-class');

const ReviewsHotels = createReactClass({
  mixins: [Helpers, DateHelper],

  propTypes: {
    pageName: string.isRequired,
    productClass: string,
    noSchemaMarkup: bool
  },

  getDefaultProps () {
    return {
      noSchemaMarkup: false
    }
  },

  shouldComponentUpdate () {
    return false
  },

  capitalize (str) {
    return str
      .toLowerCase()
      .split(' ')
      .map(a => a.charAt(0).toUpperCase() + a.substr(1))
      .join(' ')
  },

  getAirportData () {
    const { pageName } = this.props
    const airport = getAirportInfo(pageName) || { }
    if (airport.name) {
      airport.location = airport.name.replace(' ', '-')
    } else {
      airport.name = ''
      airport.code = ''
    }
    airport.type = this.getProductType()
    return airport
  },

  getProductType () {
    const { productClass } = this.props
    if (productClass === 'HCP' || productClass === 'HO') return 'hotels'
    return 'parking'
  },

  getReviewsFromFeed () {
    const { code, type, name } = this.getAirportData()
    try {
      if (code.length === 3) { // Location reviews fetch
        const { reviews } = require('../../../../../config/exports/reviews/' + type + '/' + code + '.json')
        const { meta } = require('../../../../../config/exports/reviews/' + type + '/meta/' + code + '.json')
        return this.createReviews(reviews, meta, name, type)
      }
      const { reviews } = require('../../../../../config/exports/reviews/airport' + this.capitalize(type) + 'Reviews.json')
      const { meta } = require('../../../../../config/exports/reviews/airport' + this.capitalize(type) + 'ReviewsMeta.json')
      return this.createReviews(reviews, meta, name, type)
    } catch (e) {
      if (typeof window === 'undefined') return false
      const reviews = this.$('#reviewsMenuContent')
      if (reviews) return reviews.innerHTML
      return false
    }
  },

  getReviewsPage (page) {
    try {
      const { pageName } = this.props
      if (pageName.indexOf('-reviews') > -1) return ''
      const reviewsPageData = require('../../../../../config/exports/reviews/airportParkingReviewsPages.json')
      if (reviewsPageData.indexOf(page) > -1) return page+'.html'
      return ''
    } catch (e) {
      return ''
    }
  },

  createReviews (reviews, meta, name, type) {
    type = this.capitalize(type)
    const reviewCount = meta.reviewed

    const { noSchemaMarkup, pageName } = this.props
    const link = pageName + '-reviews'
    const reviewsLink = this.getReviewsPage(link)
    const locationName = name ? name + ' ' : ''
    return (
      <div id="reviewsMenuContent">
        <h3>{ locationName }Airport { type } Reviews</h3>
        <div itemScope itemType="http://schema.org/Product">
          <p>
            <SchemaTag tagType="span" noSchemaMarkup={ noSchemaMarkup } itemProp="name">{ locationName }Airport { type }</SchemaTag> is rated, on average,
            <SchemaTag tagType="span" noSchemaMarkup={ noSchemaMarkup } itemProp="aggregateRating" itemScope itemType="http://schema.org/AggregateRating">
              <SchemaTag tagType="span" noSchemaMarkup={ noSchemaMarkup } itemProp="ratingValue"> { meta.average * 2 }/10</SchemaTag> by <SchemaTag tagType="span" noSchemaMarkup={ noSchemaMarkup } itemProp="ratingCount">{ reviewCount }</SchemaTag> Airparks customers.
            </SchemaTag>
          </p>
        </div>
        {reviewsLink &&
          <span>Check out all our
            <a href={reviewsLink} title=''> { locationName }Airport { type } Reviews</a>.
          </span>
        }
        { Object.keys(reviews).slice(-3).map(reviewKey => {
          return (
            <ReviewItem key={ reviewKey } item={ reviews[ reviewKey ] } />
         )
        })}
      </div>
   )
  },

  render() {
    const review = this.getReviewsFromFeed()

    if (!review) return null

    return (
      <div id="reviewsMenuHotels" className="well">
        { typeof review !== 'string' && review }
        { typeof review === 'string' && (
          <div dangerouslySetInnerHTML={{ __html: review }} />
       )}
      </div>
   )
  }
})

module.exports = ReviewsHotels





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/menu/reviews.jsx